import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_COMPANY_RESOURCE_GROUP,
  CLEAR_COMPANY_RESOURCE_GROUPS,
  FLAG_COMPANY_RESOURCE_GROUP_ACTIVITY,
  FLAG_GETTING_COMPANY_RESOURCE_GROUPS,
  GET_COMPANY_RESOURCE_GROUP,
  GET_COMPANY_RESOURCE_GROUPS,
} from '../../../actions/types/task-schedule';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_COMPANY_RESOURCE_GROUPS:
      return state.setIn(['all', 'loading'], payload);
    case GET_COMPANY_RESOURCE_GROUPS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_COMPANY_RESOURCE_GROUPS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_COMPANY_RESOURCE_GROUP_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_COMPANY_RESOURCE_GROUP:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_COMPANY_RESOURCE_GROUP:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
